/**
 * This map informs the user when the tax returns portal will be available for each year.
 */
export const TAX_PORTAL_DATE_MAP: Record<number, string> = {
    2024: '2025-01-13',
};

/**
 * This map informs the user of when the CRA filing deadline is for each year.
 */
export const CRA_FILING_DEADLINE_MAP: Record<number, string> = {
    2023: '2024-02-25',
    2024: '2025-02-25',
};
